import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { notify, postData } from '../functions';
import Footer from './common/Footer';
import config from '../config';

export default function Login() {
  const goto = useNavigate();
  
  const handelLogin = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const formValues = Object.fromEntries(formData.entries());

    try {
      const result = await postData(`${config.chartServerUrl}/login`, true, formValues);
      if(result?.status_code === 404){
        notify('error', result.detail);
      } else {
        if(result.practice_info){
          localStorage.setItem('practice_id', JSON.stringify(result.practice_info[0]?.practice_id));
        }

        localStorage.setItem('user', JSON.stringify(result));
        localStorage.setItem('waiting_room_date', adjustDate(new Date()));
        localStorage.setItem('waiting_room_status', 0);
        goto('/waiting-room');
      }
    } catch (error) {
      notify('error', 'Something went wrong');
    }
  }

  function adjustDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  return (
    <div >
      <Helmet>
        <title>Login | { config.appName}</title>
        <meta name="description" content="Medical Chart Management" />
      </Helmet>
      
      <div className="relative isolate">
        <div className="overflow-hidden">
          <div className="mx-auto max-w-7xl px-6 pb-32 pt-36 sm:pt-60 lg:px-8 lg:pt-32">
            <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">

              <div className="flex min-h-full flex-1 flex-col justify-center ">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                  <Link to="/">
                    <img className="mx-auto h-16 w-auto" src={`${config.appUrl}/logo.svg`} alt="Chart" />
                  </Link>                                    
                  <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-gray-200"> Sign in to your account </h2>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
                  <div className="transition-all duration-500 dark:border-slate-500 px-6 py-6 sm:rounded-lg sm:px-12">
                    <form className="space-y-6" method="POST" onSubmit={handelLogin} autoComplete='off'>
                      <div>
                        <label className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-200"> Email </label>
                        <div className="mt-2">
                          <input name="email" type="email" autoComplete="email" required
                            className="block outline-0 w-full rounded-md border-0 p-1.5 px-3 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 dark:bg-white/5 dark:text-white dark:ring-white/10 dark:focus:ring-indigo-600"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-200"> Password </label>
                        <div className="mt-2">
                          <input name="password" type="password" autoComplete="current-password" minLength={8} required
                            className="block outline-0 w-full rounded-md border-0 p-1.5 px-3 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6 dark:bg-white/5 dark:text-white dark:ring-white/10 dark:focus:ring-indigo-600"
                          />
                        </div>
                      </div>

                      <div className="flex items-center justify-between">
                        <div className="flex items-center">
                          <input id="remember-me" name="remember-me" type="checkbox"
                            className="h-4 w-4 rounded border-gray-300 text-indigo-500 focus:ring-indigo-500 "
                          />
                          <label htmlFor="remember-me" className="ml-3 block text-sm leading-6 text-gray-900 dark:text-gray-200"> Remember me </label>
                        </div>

                        <div className="text-sm leading-6">
                          <Link to="/" className="font-semibold text-indigo-500 hover:text-indigo-600">
                            Forgot password?
                          </Link>
                        </div>
                      </div>

                      <div>
                        <button type="submit" className="flex w-full items-center justify-center gap-3 rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" className="h-5 w-5 text-[fill-color]" style={{ '--grid-item-icon-stroke-width': '1.5', '--grid-item-icon-scale': '1' }} >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25" />
                          </svg>
                          <span className="text-sm font-semibold leading-6">Sign in</span>
                        </button>
                        <br></br> 
                      </div>
                    </form>
                    
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      <Footer />      
    </div>
  )
}
